import { LoginType } from './LoginType';
export class SearchCertificateFilterModel {
    certificateNumber: string;
    loginId: string;
    loginType: LoginType;
    fromQr: boolean;
}
